import { VF_TEXTAREA } from 'AppSrc/core/components/forms/form-base-components/v-f-textarea';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';

const fieldId = 'technology-plan-exclusion';

const initialValues = '';

const vFParams = {
  fieldTitle: 'Provide reason why this change does not impact our Technology Recovery Plans?',
  characterLimit: 100, // don't forget to add to validator
  placeholder: 'Enter text',
};

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  const minCharacters = 3;
  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_TEXTAREA);
  const overCharacterLimit = commonValidation.textInput.isOverCharacterLimit(values[fieldId], vFParams.characterLimit);
  const underCharacterMin = commonValidation.textInput.isUnderCharacterMinimum(values[fieldId], minCharacters);
  // const hasSpecialCharacter = commonValidation.textInput.hasSpecialCharacter(values[fieldId]);
  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please provide a reason' : null);
  errors[INLINE_ERRORS].push((underCharacterMin && !noValue) ? 'Text has too few characters' : null);
  errors[INLINE_ERRORS].push((overCharacterLimit) ? 'Text exceeds character limit' : null);
  // errors[INLINE_ERRORS].push((hasSpecialCharacter) ? 'Special character < cannot be accepted in Ace' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const whyNoChangeInTechnologyRecoveryPlans = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_TEXTAREA,
};

export { whyNoChangeInTechnologyRecoveryPlans };
